module.exports = __webpack_public_path__ + "img/frame (68).1a672963.jpg";